<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="auditoriaForm">
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <BaseInput label="Información" v-model="auditoria.informacion"></BaseInput>
                </v-col>
                <v-col cols="12">
                  <BaseInput
                    v-model="auditoria.fecha"
                    v-mask="'##/##/####'"
                    hint="Formato de fecha: DD/MM/YYYY"
                    :rules="dateRules"
                  >
                    <template v-slot:label>Fecha <span class="red--text">*</span> </template>
                  </BaseInput>
                </v-col>
                <v-col cols="12">
                  <BaseInput
                    label="Personal Emisor"
                    v-model.number="auditoria.fk_idPersonalEmisor"
                    type="number"
                    min="0"
                  ></BaseInput>
                </v-col>
              </v-row>
              <v-col cols="12">
                <BaseInput
                  label="Personal Receptor"
                  v-model.number="auditoria.fk_idPersonalReceptor"
                  type="number"
                  min="0"
                ></BaseInput>
              </v-col>
              <v-col cols="12">
                <BaseInput label="Arma" v-model.number="auditoria.fk_idArma" type="number" min="0"></BaseInput>
              </v-col>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton @click="triggerSaveAuditoria()" :loading="loading" :disabled="!auditoriaForm || loading">
        Registrar auditoría
      </TextButton>
    </v-card-actions>
  </v-card>
</template>
<script>
import moment from 'moment'
import TextButton from '@/components/base/TextButton.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import { mapActions, mapMutations } from 'vuex'

export default {
  components: {
    BaseInput,
    TextButton,
  },
  data() {
    return {
      auditoriaForm: false,
      auditoria: {
        informacion: '',
        fecha: '',
        fk_idPersonalEmisor: 0,
        fk_idPersonalReceptor: 0,
        fk_idArma: 0,
      },
      loading: false,
      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => moment(v, 'DD/MM/YYYY', true).isValid() || 'El formato de fecha debe ser DD/MM/YYYY',
      ],
    }
  },
  methods: {
    ...mapActions('armeria', ['createAuditoria']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    async triggerSaveAuditoria() {
      if (!this.auditoriaForm) return
      this.loading = true
      const payload = {
        ...this.auditoria,
        fecha: moment(this.auditoria.fecha, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        fk_idArma: Number(this.auditoria.fk_idArma),
        fk_idPersonalEmisor: Number(this.auditoria.fk_idPersonalEmisor),
        fk_idPersonalReceptor: Number(this.auditoria.fk_idPersonalReceptor),
      }
      await this.createAuditoria(payload)
      this.loading = false
      this.SET_SNACKBAR_MESSAGE('Auditoría registrada correctamente.')
      setTimeout(() => this.$emit('close'), 1500)
    },
  },
}
</script>
